<template>
  <div class="footer">   
      <!-- 河南星火时空网络科技有限公司 ©版权所有  增值电信业务经营许可证 
    <a href="https://beian.miit.gov.cn"><img src="@/assets/images/icp.png">| 豫ICP备2025130880号-2</a>
    <a href="https://beian.mps.gov.cn/#/query/websearch?code=41070202001784" rel="noreferrer" target="_blank"><img src="@/assets/images/beian.png"> | 豫公网安备备41070202001784号</a > -->
  
    
      河南源韵电子科技有限公司 ©版权所有  增值电信业务经营许可证 
    <a href="https://beian.miit.gov.cn"><img src="@/assets/images/icp.png">| 豫ICP2025156457号-1</a>
    <a href="https://beian.mps.gov.cn/#/query/websearch?code=41072702000355" rel="noreferrer" target="_blank"><img src="@/assets/images/beian.png"> | 豫公网安备41072702000355号</a >
  
  </div>
</template>



<script>
export default {

}
</script>

<style scoped>
.footer{
  width: 100%;
  height: 50px;
  text-align: center;
  background: #a3d6ff;
  line-height: 20px;
  margin-top: auto;
}

</style>